/*
* Předání multijazyčných stringů do selectu v závislosti na FE jazyku
* */
;(function(factory){
   if(typeof(define) == "function" && define.amd){
       define(function(){
           return function(select){ factory(select); };
       });
   } else {
       if(typeof(window.tail) != "undefined" && window.tail.select){
           factory(window.tail.select);
       }
   }
}(function(select){

    const locale = window.poskiLocale;

    select.strings.register("multiLanguage", {
        all: locale.enhancedSelect_all,
        none: locale.enhancedSelect_none,
        empty: locale.enhancedSelect_empty,
        emptySearch: locale.enhancedSelect_emptySearch,
        limit: locale.enhancedSelect_limit,
        placeholder: locale.enhancedSelect_chose,
        placeholderMulti: locale.enhancedSelect_choseMulti,
        search: locale.enhancedSelect_search,
        disabled: locale.enhancedSelect_disabled
    });
    return select;
}));
